import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=ade622f4&"
import script from "./BaseLoader.vue?vue&type=script&lang=js&"
export * from "./BaseLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports